import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';

import { Form, Description, Title, Input, SubmitButton } from './changePasswordForm.styles';
import messages from './changePasswordForm.messages';
import { CHANGE_PASSWORD_FIELDS as FIELDS } from '../../../../modules/auth/auth.constants';
import { hasAnyEmptyField } from '../../../../shared/utils/form';

export const ChangePasswordForm = ({ values: formValues, intl, isSubmitting, handleSubmit }) => {
  const hasEmptyFields = hasAnyEmptyField(formValues);

  const handleFormSubmit = e => {
    e.preventDefault();
    handleSubmit(e);
  };

  return (
    <Form onSubmit={handleFormSubmit}>
      <Title>
        <FormattedMessage {...messages.title} />
      </Title>
      <Description>
        <FormattedMessage {...messages.description} />
      </Description>
      <Field
        name={FIELDS.password}
        render={({ field, form }) => (
          <Input
            {...field}
            error={form.errors[FIELDS.password]}
            touched={form.touched[field.name]}
            type="password"
            label={intl.formatMessage(messages.fieldLabel)}
            placeholder={intl.formatMessage(messages.fieldLabel)}
          />
        )}
      />
      <SubmitButton
        type="submit"
        disabled={hasEmptyFields || isSubmitting}
        label={intl.formatMessage(messages.buttonLabel)}
      />
    </Form>
  );
};

ChangePasswordForm.propTypes = {
  intl: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
